import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

import i18n  from "@/plugin/vuei18n";

const router =  new Router({
	mode: 'history',
	fallback: false,
	routes: [
		{
			path: '/:lang'
		}
	]
});

const getCookie = cname => {
	const name = cname + '=';
	const ca = document.cookie.split(';');

	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}

		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}

	return '';
};

router.beforeEach((to, from, next) => {
	const locale = getCookie('netpeaksoftware_locale');
	let lang = to.params.lang;
	if (!lang) lang = 'en';
	if (!['ru', 'en'].includes(lang)) return next('/');
	if (i18n.locale !== lang) i18n.locale = lang === 'ru' ? 'ru' : 'en';
	if (locale && i18n.locale !== locale) return next(locale === 'ru' ? '/ru' : '/');
	return next()
});

export default router;